import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../js/coreRuntime.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../KClassJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../js/typeCheckUtils.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../collections/_Collections.mjs';
import { plus17rl43at52ays as plus } from '../../../Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KTypeImplClass;
function KTypeImpl() {
  if (KTypeImplClass === VOID) {
    class $ {
      constructor(classifier, arguments_0, isMarkedNullable) {
        this.pf_1 = classifier;
        this.qf_1 = arguments_0;
        this.rf_1 = isMarkedNullable;
      }
      sf() {
        return this.pf_1;
      }
      tf() {
        return this.qf_1;
      }
      uf() {
        return this.rf_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof KTypeImpl()) {
          tmp_1 = equals(this.pf_1, other.pf_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(this.qf_1, other.qf_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.rf_1 === other.rf_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(imul(hashCode(this.pf_1), 31) + hashCode(this.qf_1) | 0, 31) + getBooleanHashCode(this.rf_1) | 0;
      }
      toString() {
        var tmp = this.pf_1;
        var kClass = isInterface(tmp, KClass()) ? tmp : null;
        var classifierName = kClass == null ? toString(this.pf_1) : !(kClass.ff() == null) ? kClass.ff() : '(non-denotable type)';
        var args = this.qf_1.i1() ? '' : joinToString(this.qf_1, ', ', '<', '>');
        var nullable = this.rf_1 ? '?' : '';
        return plus(classifierName, args) + nullable;
      }
    }
    initMetadataForClass($, 'KTypeImpl');
    KTypeImplClass = $;
  }
  return KTypeImplClass;
}
//region block: exports
export {
  KTypeImpl as KTypeImpl31l2cx2hil3il,
};
//endregion

//# sourceMappingURL=KTypeImpl.mjs.map
